import { Server } from 'http';
import _ from 'lodash';
import {
    Application, ApplicationBulkAssignWorkspaceRequest,
    ApplicationBulkDeleteRequest, ApplicationCollection, ApplicationCreationRequest,
    ApplicationsClient, ApplicationSynchronizeRequest, ApplicationUpdateRequest,
    IApplicationCreationRequest, IApplicationUpdateRequest, ApplicationMaintenanceModeRequest
} from '../clients/aasServerClient.generated';
import { TableFilters, TableSorting } from '../stores/tables/state';

export async function getServerAliases(): Promise<string[]> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    const response = await client.getServerAliases();
    return response;
}

export  async function getApplicationsId(searchString: string,filters: TableFilters ) : Promise<string []>
{
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    let applications = await client.getApplications(false,undefined,undefined,undefined,undefined,filters.u, filters.w, filters.s,
        filters.t,searchString);
    let ret: string [] = [] ;
    applications.items.forEach(element => {ret.push( element.id)});
    return ret;
}


export function getApplications(
    limit: number, start: number,
    sorting: TableSorting,
    filters: TableFilters,
    searchString?: string
): Promise<ApplicationCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.getApplications(
        false, true,
        limit, start, ordering,
        filters.u, filters.w, filters.s,
        filters.t, searchString
    );
}
export function getApplicationsNF(
    limit: number, start: number,
    sorting: TableSorting,
    searchString?: string
): Promise<ApplicationCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.getApplications(
        false, true,
        limit, start, ordering,
        undefined, undefined, undefined,
        undefined, searchString
    );
}

export function getAllApplications(): Promise<ApplicationCollection> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.getApplications(
        true, undefined, undefined,
        undefined, undefined, undefined,
        undefined, undefined, undefined,
        undefined
    );
}

export function getApplication(id: string): Promise<Application> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.getApplication(id);
}

export function updateApplication(
    application: Partial<Application>,
    workspace?: string,
    server?: string,
): Promise<Application> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    const data: IApplicationUpdateRequest =
        _.assign(application, {
            serverHostname: server,
            workspace,
        }) as unknown as IApplicationUpdateRequest;
    return client.updateApplication(application.id!, new ApplicationUpdateRequest(data));
}

export function createApplication(
    application: Partial<Application>,
    workspace?: string,
    server?: string,
): Promise<Application> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    const data: IApplicationCreationRequest =
        _.assign(application, {
            serverHostname: server,
            workspace,
        }) as unknown as IApplicationCreationRequest;
    return client.createApplication(new ApplicationCreationRequest(data));
}

export function deleteApplications(ids: string[]) {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeleteApplications(new ApplicationBulkDeleteRequest({ ids }));
}

export function synchronize(ids: string[]) {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.bulkSynchronize2(new ApplicationSynchronizeRequest({ ids }));
}

export function assignApplicationsWorkspace(applicationIds: string[], workspaceId: string) {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignWorkspace(
        new ApplicationBulkAssignWorkspaceRequest({ applications: applicationIds, workspace: workspaceId })
    );
}

export function getMaintenanceMode(id: string): Promise<boolean> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.getMaintenanceMode(id);
}

export function setMaintenanceMode(id: string, value: boolean): Promise<boolean> {
    const client = new ApplicationsClient(process.env.PUBLIC_URL + '/api');
    return client.setMaintenanceMode(id, new ApplicationMaintenanceModeRequest({value}));
}
